import React from 'react'

export default function IntroStandalone () {
    return <div className="adobe-app-main">
        <iframe title="Remove Background Standalone" frameBorder="0" className='adobe-app-iframe' src={`${process.env.REACT_APP_DISDK_ADOBE_EXPRESS_INTRO}`} />
    </div>
}
